import { Box, CircularProgress } from '@mui/material';
import Spinner from 'client/modules/App/components/Spinner/Spinner';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const loadingMessage = {
  id: 'Spinner.Loading',
  defaultMessage: 'Loading...',
};

function ActivityIndicatorLabel() {
  return <FormattedMessage {...loadingMessage} />;
}

function ActivityIndicator({ inline = false, size = 24, sx, className }) {
  const { formatMessage } = useIntl();

  if (inline) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', py: 2, ...sx }}
        className={className}
      >
        <CircularProgress size={size} aria-label={formatMessage(loadingMessage)} />
      </Box>
    );
  }

  return <Spinner className={className} />;
}

ActivityIndicator.Label = ActivityIndicatorLabel;

export default ActivityIndicator;
